module.exports = __webpack_public_path__ + "static/media/up.f20dca74.svg";